import { render } from "./Financas.vue?vue&type=template&id=4a2ea9c0"
import script from "./Financas.vue?vue&type=script&lang=js"
export * from "./Financas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__